import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import {NotificationManagerService} from '../../../../common/services/notification-manager.service';
import {BusinessModel} from '../../../../core-logic/models/business/business-model';
import {UserModel} from '../../../../core-logic/models/user/user-model';
import {StorageManagerGatewayCapacitor} from '../../../../adapters/real/app-services/storage-manager-gateway-capacitor';
import {BusinessMemberRoleList} from '../../../../common/enums/business-member-role-list';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnChanges {
  @Input() isHomePage = false;
  @Input() hideProgressBar = true;
  @Input() userType: 'business' | 'customer';
  @Input() leftButton: {icon: string, route: string []};
  @Input() title: string;
  @Input() subtitle: string;
  @Input() currentBusiness: BusinessModel;
  @Input() businessFabButtons: {icon: string, route: string[]} [];
  @Input() preventDefaultBackButton = false;
  @Output() backButtonClick = new EventEmitter<boolean>();
  realBusinessFabButtons = [
    {label: 'Pte-monnaie', icon: 'wallet.svg', route: []},
    {label: 'Stats', icon: 'statistic.svg', route: []},
    {label: 'Notifs', icon: 'notifications.svg', route: []},
    {label: 'Params', icon: 'options.svg', route: []},
  ];
  @Input() customerFabButtons: {icon: string, route: string[]} [];
  realCustomerFabButtons = [
    {label: 'Notifications', icon: 'notifications.svg', route: ['/customer/notification']},
    {label: 'Porte-carte', icon: 'gallery.svg', route: ['/customer/cards-gallery']}
  ];
  @Input() stepBars: {stepBar: number, step: number};
  hasNotSeenCustomerNotifications: boolean;
  hasNotSeenMerchantNotifications: boolean;
  @Input() hasSeenMerchantNewOptions: boolean;
  private currentUser: UserModel;
  constructor(
    private notificationManagerService: NotificationManagerService,
    private storageManagerGatewayCapacitor: StorageManagerGatewayCapacitor
  ) {
    this.storageManagerGatewayCapacitor.getCurrentUser().subscribe(currentUser => this.currentUser = currentUser);
    this.notificationManagerService.getCustomerNotifications$().subscribe(notifications => {
      this.hasNotSeenCustomerNotifications = !!notifications.find(notification => !notification.seen_date)
    });
    this.notificationManagerService.getMerchantNotifications$().subscribe(notifications => {
      this.hasNotSeenMerchantNotifications = !!notifications.find(notification => !notification.seen_date)
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.businessFabButtons && changes.businessFabButtons.currentValue) {
      this.businessFabButtons = changes.businessFabButtons.currentValue;

      this.businessFabButtons.forEach(businessFabButton => {
        this.realBusinessFabButtons[
          _.findIndex(this.realBusinessFabButtons,{
            icon: businessFabButton.icon })
          ].route = businessFabButton.route;

        return businessFabButton;
      });
    }
    else if (changes.customerFabButtons && changes.customerFabButtons.currentValue) {
      this.customerFabButtons = changes.customerFabButtons.currentValue;

      this.customerFabButtons.forEach(customerFabButton => {
        this.realCustomerFabButtons[
          _.findIndex(this.customerFabButtons,{
            icon: customerFabButton.icon })
          ].route = customerFabButton.route;

        return customerFabButton;
      });
    }
  }

  hasButtonAccess(buttonIcon: string): boolean {
    const isOwnerOrAdministrator = this.currentBusiness?.members?.some(member => member.role === BusinessMemberRoleList.ADMINISTRATOR
      && member.user._id === this.currentUser?._id) || this.currentUser?._id === this.currentBusiness?.owner?._id;
    const isManager = this.currentBusiness?.members?.some(member => member.role === BusinessMemberRoleList.MANAGER
      && member.user._id === this.currentUser?._id);
    switch (buttonIcon) {
      case 'wallet.svg' :
      case 'options.svg' :
        return isOwnerOrAdministrator;
      case 'statistic.svg' :
        return isOwnerOrAdministrator || isManager;
    }
    return true;
  }

  onArrowBackIconClick() {
    this.backButtonClick.emit(true);
  }
}
